import { render, staticRenderFns } from "./TitleDeedAlternativesList.vue?vue&type=template&id=55288c60&"
import script from "./TitleDeedAlternativesList.vue?vue&type=script&lang=js&"
export * from "./TitleDeedAlternativesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports